
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M38.5 12.833h-33A1.834 1.834 0 013.667 11V7.333c0-1.012.821-1.833 1.833-1.833h33c1.012 0 1.833.821 1.833 1.833V11a1.834 1.834 0 01-1.833 1.833zM16.5 20.167h11"}}),_c('path',{attrs:{"d":"M37.89 12.833v22a3.666 3.666 0 01-3.667 3.667H9.777a3.666 3.666 0 01-3.667-3.667v-22"}})]),_c('g',{staticClass:"bcx-icon-shadow"},[_c('path',{attrs:{"d":"M18.86 32h1.581v-2.949h1.67c2.016 0 3.099-1.21 3.099-2.89 0-1.665-1.07-2.888-3.077-2.888H18.86V32zm1.581-4.249v-3.157h1.45c1.184 0 1.708.639 1.708 1.568s-.524 1.59-1.7 1.59H20.44z","fill":"currentColor"}})])])
          )
        }
      }
    